/// <reference path="../../app.definition.ts" />

/*
* eCareVault.IUserStateService
* author: Ian Tripp
*/
import angular from "angular";
import { IUserService, UserService } from "@common/service/user.service";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";

export interface IUserStateService {
    init(): void;
    getState(key: string): any;
    setState(key: string, val: any): void;
    checkState(key: string, checkVal: any): boolean;
    getSetting(key: string): any;
    setSetting(key: string, val: any): void;
}

let devEnvs = [
    'dev',
    'ecv-dev',
    'jeavio-dev'
]

export const KEY_NAME: string = "account_id";

export class UserStateService implements IUserStateService {
    svcName: string = 'eCareVault.UserStateService';

    public STATE_TABLE: string;

    testSettings = {
        'DISABLE_NUDGES': false
    }

    defaultStates = {
        'USER_ADDED_DISC': false, // User has ever started a Discussion
        'USER_ADDED_DOC': false, // User has ever uploaded a document
        'USER_ADDED_TM': false, // User has ever added a TM

        //TOUR DONE STATES
        'NEW_USER_INVITE_TOUR': false,
        'USER_DOC_TOUR': false,
        'USER_DISC_TOUR': false,
        'USER_BUILD_TOUR': false
    }
    userId: number;
    userSettings: any;
    userStates: any;

    static $inject = ["UserService", "ApiAdapterService", "ecareEnv"];
    constructor(
        private $_user: IUserService,
        private $_api: JavaApiAdapterService,
        private ecareEnv: string
    ) {
        this.userStates = {};
        this.userSettings = this.testSettings;
        this.STATE_TABLE = "ecv_user_states_" + (this.isDev() ? 'dev' : (this.ecareEnv == 'qa2' ? 'qa' : this.ecareEnv));
    }

    init = () => {
        // Init the DynamoDB service if not already
        // !this.$_dynamo.initialized && this.$_dynamo.init();
        this.userId = this.$_user.getMyId();
        this.loadUserStates();
    }

    isDev = (): boolean => {
        return !!devEnvs.find((o) => o == this.ecareEnv);
    }
    // Compare a state value against a passed value
    checkState = (key: string, checkVal: any): boolean => {
        // console.log("Comparing key", key, 'on', this.userStates[key], "with", checkVal, this.userStates[key] === checkVal ? 'Match' : 'No Match', this.userStates);
        return this.userStates[key] === checkVal;
    }

    getState = (key: string): any => this.userStates[key] || null;
    setState = (key: string, val: any): void => {
        if (val !== this.userStates[key]) {
            this.userStates[key] = val;
            this.updateUserState(key, val);
        }
    }

    getSetting = (key: string): any => this.userSettings[key];
    setSetting = (key: string, val: any): void => (this.userSettings[key] = val);

    // Create new copy of State settings and store it in DynamoDB for user
    createUserStates = () => {
        let params = angular.copy(this.defaultStates);
        this.$_api.userStats().then(
            stats => {
                for (let stat in stats) {
                    switch (stat) {
                        case 'documentCount':
                            params['USER_ADDED_DOC'] = stats[stat] > 0;
                            break;
                        case 'discussionCount':
                            params['USER_ADDED_DISC'] = stats[stat] > 0;
                            break;
                        case 'tmAddedCount':
                            params['USER_ADDED_TM'] = stats[stat] > 0;
                            break;
                    }
                }
            },
            e => {
                console.warn("UserStateService: could not load user stats, using default");
            }
        ).finally(
            () => {
                // this.$_dynamo.createItem(this.STATE_TABLE, KEY_NAME, this.userId.toString(), params).then(
                //     data => {
                //         console.log("User State created:", params);
                //         this.userStates = params;
                //     },
                //     err => {
                //         // console.error("User State could not be created:", err);
                //     }
                // )
            }
        );
    }

    // Load the user states from the DynamoDB service, which hits Amazon Dynamo DB
    loadUserStates = () => {
        // this.$_dynamo.getItem(this.STATE_TABLE, KEY_NAME, this.userId.toString()).then(
        //     data => {
        //         // Make sure not empty return
        //         if (!angular.equals(data, {})) {
        //             this.userStates = data.Item;
        //             // console.log("User State loaded:", this.userStates);
        //         } else {
        //             // console.log("User State empty, creating new from default");
        //             this.createUserStates()
        //         }
        //     },
        //     err => {
        //         // If not found, initialize new copy
        //         // console.log("User State not found, creating new from default");
        //         this.createUserStates()
        //     }
        // );
    }

    updateUserState = (state: string, val: any) => {
        let params: any = {};
        params[state] = val;
        // this.$_dynamo.updateItem(this.STATE_TABLE, KEY_NAME, this.userId.toString(), params);
    }

    clearState = (): void => {
        // this.$_dynamo.updateItem(this.STATE_TABLE, KEY_NAME, this.userId.toString(), this.defaultStates);
    }
}

angular.module('eCareVault.common.services')
    .service('UserStateService', UserStateService);
